var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.can_access('email','view'))?_c('div',{staticClass:"row"},[_vm._m(0),_c('div',{staticClass:"col-md-12"},[(_vm.can_access('email','view') && _vm.emailTableView)?_c('TableView',{attrs:{"col":_vm.columns,"getData":_vm.getData}}):_vm._e()],1)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12",staticStyle:{"display":"block ruby"}},[_c('h1',{},[_vm._v("Email Server")])])
}]

export { render, staticRenderFns }